module.exports = __webpack_public_path__ + "static/img/wenhuajingying.311c1e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wenhuajingying.png
// module id = uLF7
// module chunks = 1